import { TextWrap } from "../../../../base/styles";
import clsx from "clsx";

export const SelectTextWrap = ({ title, value, className, onChange }:{
    title: string,
    value?: TextWrap,
    className?: string,
    onChange: (value?: TextWrap) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as TextWrap;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={TextWrap.Wrap}>Wrap</option>
                <option value={TextWrap.NoWrap}>No Wrap</option>
            </select>
        </div>
    )
}